import { IconCheck } from "@tabler/icons-react"
import { IconNavion } from "@tfg/ui"
import { useMemo } from "react"

import { useGetOperations } from "~/utils/operations"

type Props = {
  progress: number
  activityName: string
  size?: number
  isTransferred?: boolean
}

export const ActivityProgressIcon = ({
  progress,
  activityName,
  size = 20,
  isTransferred = false,
}: Props) => {
  const operations = useGetOperations()
  const ActivityIconComponent = operations[activityName].icon

  const isCompleted = useMemo(() => {
    return progress === 100
  }, [progress])

  if (isTransferred)
    return <IconNavion size={size} color="var(--mantine-color-primary-4)" />

  if (isCompleted)
    return <IconCheck size={size} color="var(--mantine-color-primary-4)" />
  if (ActivityIconComponent) return <ActivityIconComponent size={size} />
  return null
}
